const POSTHOG_DIRECT_HOST = 'https://eu.i.posthog.com'
const POSTHOG_PROXY_PATH = '/ph-relay'

// Environments served by the K8s/nginx image rather than Vercel. Their
// frontends sit behind a CloudFront distribution whose default cache behaviour
// only allows GET/HEAD (edge-delivery module), so the POST that posthog-js
// issues to the same-origin `/ph-relay/flags/` endpoint is rejected at the edge
// (403, then rewritten to index.html by custom_error_response) — feature flags
// silently never load. These environments therefore talk to PostHog directly,
// exactly as goodstacktesting.com does. Vercel-hosted envs (plain `staging`,
// `sandbox`, production) keep `/ph-relay`, which their vercel.json rewrites
// handle correctly.
//
// Source of truth for this list is the K8s deploy targets in
// `.github/workflows/deployment-all.yml` (the workflow_dispatch `environment`
// options); there is no importable constant, so keep the two in sync by hand.
export const K8S_ENVIRONMENTS = [
  'staging-apple',
  'staging-banana',
  'staging-cherry',
  'performance',
  'training',
  'sandbox-lab',
]

export function getPostHogApiHost(hostname: string): string {
  const isGoodstackTesting =
    hostname === 'goodstacktesting.com' ||
    (hostname.endsWith('.goodstacktesting.com') &&
      !hostname.endsWith('.pr.goodstacktesting.com'))

  // Hosts are `<app>.<environment>.<tld>` (e.g. partners.staging-cherry.goodstack.io),
  // so match the environment on a whole dns label — `sandbox-lab` must not match
  // the Vercel-hosted `sandbox`, nor `staging-cherry` the Vercel-hosted `staging`.
  const isK8sEnvironment = hostname.split('.').some(label => K8S_ENVIRONMENTS.includes(label))

  return isGoodstackTesting || isK8sEnvironment ? POSTHOG_DIRECT_HOST : POSTHOG_PROXY_PATH
}
